
const { useDisclosure, DrawerOverlay, Drawer, DrawerContent, DrawerBody, DrawerFooter, DrawerCloseButton, DrawerHeader, Box } = require("@chakra-ui/react")
const { useRef, useContext, createContext } = require("react")

export const DrawerContext = createContext(null);

export const ActionDrawer = ({ title, trigger, children, actions, size, close }) => {

  const { isOpen, onOpen, onClose } = useDisclosure()

  const closeDrawer = () => {
    onClose()
  }

  return (
    <>
      <Box onClick={onOpen}>
        {trigger}
      </Box>
      <DrawerContext.Provider
        value={{
          isOpen: isOpen, 
          onOpen: onOpen, 
          closeDrawer: closeDrawer
        }}
      >
        <Drawer
          isOpen={isOpen}
          placement='right'
          onClose={onClose}
          size={size || 'md'}
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            {/* Room on the right for the close button, so a long title wraps instead of running under it */}
            <DrawerHeader pr={14} lineHeight='short' wordBreak='break-word'>{title}</DrawerHeader>
              { children }
          </DrawerContent>
        </Drawer>
      </DrawerContext.Provider>
        
    </>
  )
}